import { Theme, useMediaQuery } from '@mui/material';
import { useQuery } from 'react-query';
import {
  HomeLocationIcon,
  HomeTimeLocation,
  HomeZapIcon,
  RightPointedArrow,
  SupportCartIcon,
  SupportHelpIcon
} from '../../assets/Icons';
import { Png } from '../../assets/Png';
import { Spacer } from '../../components/atoms';
import { Reveal } from '../../components/atoms/Container/Reveal';
import {
  BestPrice,
  CategoriesGrid,
  MadinaFeatures,
  Reviews,
  SeamlessShopping,
  VendorsGrid
} from '../../components/molecules';
import LandingPageLocationInput from '../../components/molecules/m-landing-page-location-input';
import { getAllCategories } from '../../network/services/goods';
import { HeroCon, HeroRightCon, HomePageCon, SubHero, SubHeroCard, SupportSection, SupportSectionCard } from './style';

export const HomePage = () => {
  const { heroBg, MobileheroBg } = Png;
  const lg = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  const { data } = useQuery(['categories'], () => getAllCategories());
  const categories = data || [];

  return (
    <HomePageCon>
      <HeroCon bg={lg ? heroBg : MobileheroBg}>
        <div className="hero-content">
          <HeroRightCon>
            <Reveal>
              <h3>Online Supermarket for all your needs.</h3>
            </Reveal>
            <Spacer height="1em" />
            <Reveal>
              <p className="text-center">Madina Lifestyle Supermarket: Nigeria's Premier Family Discount Haven</p>
            </Reveal>
            <Reveal>
              <LandingPageLocationInput />
            </Reveal>
          </HeroRightCon>
        </div>
      </HeroCon>
      <SubHero className="relative">
        <img className="absolute -top-1 w-screen right-0" alt="waves_top" src="/graphics/waves_top.svg" />
        <div className="content mt-28">
          <SubHeroCard color="#1AB66E">
            <div className="card-icon">
              <HomeLocationIcon />
            </div>
            <p className="title">Fast Delivery</p>
            <p className="desc">Share your referral code and earn amazing rewards.</p>
          </SubHeroCard>

          <SubHeroCard color="#FDC20B">
            <div className="card-icon">
              <HomeZapIcon />
            </div>
            <p className="title">24/7 Customer Support</p>
            <p className="desc">Share your referral code and earn amazing rewards.</p>
          </SubHeroCard>

          <SubHeroCard color="#2F4DC4">
            <div className="card-icon">
              <HomeTimeLocation />
            </div>
            <p className="title">14 -Days Return Policy</p>
            <p className="desc">Share your referral code and earn amazing rewards.</p>
          </SubHeroCard>
        </div>
      </SubHero>
      <VendorsGrid />
      <SeamlessShopping />
      <MadinaFeatures />
      <Spacer height={`${lg ? '60px' : '20px'}`} />
      <CategoriesGrid categories={categories} />
      <BestPrice />
      <Reviews />
      <SupportSection>
        <div className="content">
          <SupportSectionCard>
            <div className="card-icon">
              <SupportCartIcon />
            </div>
            <p className="title">
              <span>How to shop</span>
              <RightPointedArrow />
            </p>
            <p className="desc">Your guide to shopping and placing orders.</p>
          </SupportSectionCard>
          <SupportSectionCard>
            <div className="card-icon">
              <SupportHelpIcon />
            </div>
            <p className="title">
              <span>FAQ</span>
              <RightPointedArrow />
            </p>
            <p className="desc">Your questions answered.</p>
          </SupportSectionCard>
          <SupportSectionCard>
            <div className="card-icon">
              <SupportCartIcon />
            </div>
            <p className="title">
              <span>Need help?</span>
              <RightPointedArrow />
            </p>
            <p className="desc">Contact our customer support team.</p>
          </SupportSectionCard>
        </div>
      </SupportSection>
    </HomePageCon>
  );
};
